/**
 * Fixes the parallax text not appearing on Safari issue
 */
export const fixSafariParallax = () => {
  setTimeout(() => {
    document
      .querySelectorAll('.bo-parallax__scroll-content')
      .forEach(element => {
        const el = element as HTMLElement;

        el.style.transform = 'translate3d(0, 0, 0)';
      });
  }, 1000);
};
